// Built-in library of common NZ construction / civil hazardous substances.
// Selecting one auto-fills the hazard details; the user then only sets the
// site-specific bits (storage location, maximum quantity on site).
//
// NOTE: classifications below are standard, generic guidance for the common
// product type. The actual supplier Safety Data Sheet (SDS) is still the
// authoritative record and should be attached to the substance after adding.

export const HAZARDOUS_CATALOGUE = [
  {
    key: "diesel",
    product_name: "Diesel (Automotive)",
    category: "Fuels & oils",
    un_number: "UN1202",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Danger",
    hazard_summary: "Flammable liquid. Harmful if swallowed and enters airways (aspiration). Skin and respiratory irritant; suspected carcinogen on prolonged exposure.",
    hazard_classifications: ["Flammable Liquid Cat 4", "Aspiration Hazard Cat 1", "Skin Irritation Cat 2", "Aquatic Chronic Cat 2", "Carcinogenicity Cat 2"],
    pictograms: ["Flammable", "Health hazard", "Environment"],
    ppe: ["Nitrile gloves", "Safety glasses", "Fuel-resistant footwear"],
    handling: "Keep away from heat, sparks and open flame. No smoking. Use in well-ventilated areas. Bond and earth containers when transferring. Avoid skin and eye contact.",
    storage: "Store in a cool, well-ventilated area in approved, labelled containers. Keep away from oxidisers. Provide secondary containment (bunding) to prevent ground/waterway contamination.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "Skin: wash with soap and water. Eyes: rinse with water. Swallowed: do NOT induce vomiting — seek medical advice immediately. Inhalation: move to fresh air.",
    spill_response: "Eliminate ignition sources. Contain with spill kit / absorbent, prevent entry to drains and waterways. Collect into labelled waste containers.",
    fire_response: "Use foam, dry powder or CO2. Do not use water jet. Cool exposed containers.",
    emergency_notes: "In a fire or large spill, evacuate and call 111. For poisoning advice call the National Poisons Centre 0800 764 766.",
  },
  {
    key: "petrol",
    product_name: "Petrol (Unleaded)",
    category: "Fuels & oils",
    un_number: "UN1203",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Danger",
    hazard_summary: "Extremely flammable liquid and vapour. Harmful if swallowed and enters airways. May cause drowsiness or dizziness. Suspected carcinogen (benzene).",
    hazard_classifications: ["Flammable Liquid Cat 1", "Aspiration Hazard Cat 1", "Carcinogenicity Cat 1B", "STOT Single Cat 3", "Aquatic Chronic Cat 2"],
    pictograms: ["Flammable", "Health hazard", "Environment"],
    ppe: ["Nitrile gloves", "Safety glasses", "Fuel-resistant footwear"],
    handling: "Highly flammable — keep well away from all ignition sources. No smoking. Ground/bond containers when decanting. Use only in well-ventilated areas; avoid breathing vapour.",
    storage: "Store in approved flammable-liquid containers in a cool, ventilated, flammables store away from ignition and oxidisers. Keep quantities to the minimum needed on site.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "Swallowed: do NOT induce vomiting — urgent medical attention. Eyes/skin: rinse thoroughly. Inhalation: move to fresh air; if unwell seek medical advice.",
    spill_response: "Remove all ignition sources. Ventilate. Contain with non-sparking tools and absorbent; keep out of drains. Vapour is heavier than air and travels — watch low areas.",
    fire_response: "Foam, dry powder or CO2. Never use a water jet. Evacuate and cool containers from a protected position.",
    emergency_notes: "Fire or major spill: evacuate, call 111. Poisons advice: National Poisons Centre 0800 764 766.",
  },
  {
    key: "lpg",
    product_name: "LPG (Liquefied Petroleum Gas)",
    category: "Compressed gases",
    un_number: "UN1075",
    default_unit: "kg",
    physical_form: "Liquefied gas under pressure",
    signal_word: "Danger",
    hazard_summary: "Extremely flammable gas. Contains gas under pressure — may explode if heated. Vapour is heavier than air and can collect in low areas.",
    hazard_classifications: ["Flammable Gas Cat 1", "Gas Under Pressure (Liquefied)"],
    pictograms: ["Flammable", "Gas cylinder"],
    ppe: ["Gloves for cylinder handling", "Safety glasses"],
    handling: "Keep away from heat and ignition. Secure cylinders upright. Check fittings/hoses for leaks with soapy water — never a flame. Use and store outdoors or in well-ventilated areas only.",
    storage: "Store upright in a secured, ventilated outdoor cage away from drains, pits and ignition sources. Keep full and empty cylinders separated and clearly marked.",
    incompatibilities: "Oxidisers.",
    first_aid: "Frostbite from liquid contact: flush with lukewarm water, do not rub. Inhalation: move to fresh air. Seek medical advice if symptoms persist.",
    spill_response: "Leak: stop the source if safe, eliminate ignition, ventilate, evacuate downwind/low areas. Do not enter gas-filled low spaces.",
    fire_response: "If safe, shut off supply. Cool cylinders with water from a protected position. Do not extinguish a gas fire unless the leak can be stopped.",
    emergency_notes: "Gas leak or fire: evacuate, keep clear of low areas, call 111.",
  },
  {
    key: "oxygen",
    product_name: "Oxygen (Compressed)",
    category: "Compressed gases",
    un_number: "UN1072",
    default_unit: "each",
    physical_form: "Compressed gas",
    signal_word: "Danger",
    hazard_summary: "Oxidiser — vigorously accelerates combustion. Contains gas under pressure; may explode if heated. Keeps fires burning even without other air.",
    hazard_classifications: ["Oxidising Gas Cat 1", "Gas Under Pressure (Compressed)"],
    pictograms: ["Oxidiser", "Gas cylinder"],
    ppe: ["Clean gloves (oil-free)", "Safety glasses"],
    handling: "Keep oil and grease well away from cylinders, valves and fittings. Secure cylinders upright. Open valves slowly. Never use oxygen as a substitute for compressed air.",
    storage: "Store upright and secured in a ventilated area. Separate oxygen cylinders from flammable gases (e.g. acetylene/LPG) by at least 3 m or a fire-rated barrier.",
    incompatibilities: "Oils, greases, flammable gases and liquids.",
    first_aid: "Oxygen-enriched clothing is a severe fire risk — ventilate before approaching ignition. Seek medical advice for any exposure symptoms.",
    spill_response: "Leak: stop source if safe, ventilate, remove ignition sources and combustible materials, evacuate the area.",
    fire_response: "Shut off supply if safe. Cool cylinders with water from a protected position; oxygen greatly intensifies any fire.",
    emergency_notes: "Leak or fire: clear the area of all ignition and combustibles, call 111.",
  },
  {
    key: "acetylene",
    product_name: "Acetylene (Dissolved)",
    category: "Compressed gases",
    un_number: "UN1001",
    default_unit: "each",
    physical_form: "Dissolved gas under pressure",
    signal_word: "Danger",
    hazard_summary: "Extremely flammable gas. Contains gas under pressure. May form explosive mixtures with air and react dangerously with copper and brass.",
    hazard_classifications: ["Flammable Gas Cat 1", "Gas Under Pressure (Dissolved)"],
    pictograms: ["Flammable", "Gas cylinder"],
    ppe: ["Gloves", "Safety glasses", "Welding PPE when in use"],
    handling: "Always use and store cylinders upright. Use approved flashback arrestors and regulators. Never exceed recommended withdrawal rates. Keep away from ignition and oxygen cylinders.",
    storage: "Store upright and secured in a ventilated outdoor cage, separated from oxygen by at least 3 m or a fire-rated barrier. Protect from heat.",
    incompatibilities: "Oxygen and oxidisers; copper, silver and brass fittings.",
    first_aid: "Inhalation: move to fresh air. Frostbite: flush with lukewarm water. Seek medical advice if unwell.",
    spill_response: "Leak: stop source if safe, eliminate ignition, ventilate, evacuate. Treat a leaking cylinder as an immediate fire risk.",
    fire_response: "Shut off supply if safe; otherwise evacuate and cool the cylinder with water from a protected position — acetylene cylinders can become unstable when heated.",
    emergency_notes: "Heated or leaking cylinder: evacuate to a safe distance and call 111 — advise Fire & Emergency it is acetylene.",
  },
  {
    key: "engine-oil",
    product_name: "Engine / Lubricating Oil",
    category: "Fuels & oils",
    un_number: "",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Warning",
    hazard_summary: "Not classified as acutely dangerous but may cause skin irritation/dermatitis on repeated contact. Harmful to aquatic life.",
    hazard_classifications: ["Aquatic Chronic Cat 3", "Skin Irritation (repeated contact)"],
    pictograms: ["Environment"],
    ppe: ["Nitrile gloves", "Safety glasses"],
    handling: "Avoid prolonged skin contact. Wash hands before eating. Prevent spills to ground and waterways.",
    storage: "Store in labelled containers with secondary containment. Keep used oil separate for recycling/disposal.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "Skin: wash with soap and water. Eyes: rinse with water. Swallowed: do not induce vomiting; seek medical advice.",
    spill_response: "Contain with absorbent, keep out of drains, collect for recycling/disposal.",
    fire_response: "Foam, dry powder or CO2. Do not use water jet.",
    emergency_notes: "Large spill to drain/waterway: contain and notify the site manager and regional council.",
  },
  {
    key: "hydraulic-oil",
    product_name: "Hydraulic Oil",
    category: "Fuels & oils",
    un_number: "",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Warning",
    hazard_summary: "Low acute hazard. Pressurised injection injuries from hydraulic lines are a serious risk. Harmful to aquatic life.",
    hazard_classifications: ["Aquatic Chronic Cat 3"],
    pictograms: ["Environment"],
    ppe: ["Nitrile gloves", "Safety glasses"],
    handling: "Never check for hydraulic leaks with bare hands — high-pressure injection injuries need urgent medical care. Avoid skin contact and prevent spills.",
    storage: "Store in labelled containers with secondary containment away from oxidisers.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "High-pressure injection injury: treat as a surgical emergency — call 111. Skin: wash. Eyes: rinse.",
    spill_response: "Contain with absorbent, keep out of drains, collect for disposal.",
    fire_response: "Foam, dry powder or CO2. Do not use water jet.",
    emergency_notes: "Suspected fluid injection injury: urgent medical attention, call 111.",
  },
  {
    key: "cement",
    product_name: "Portland Cement",
    category: "Concrete & masonry",
    un_number: "",
    default_unit: "kg",
    physical_form: "Powder",
    signal_word: "Danger",
    hazard_summary: "Causes serious eye damage and skin burns/irritation (alkaline). Wet cement is corrosive to skin. Contains crystalline silica — do not breathe dust.",
    hazard_classifications: ["Skin Irritation Cat 2", "Serious Eye Damage Cat 1", "STOT Single Cat 3 (respiratory)", "Carcinogenicity Cat 1A (silica, inhalable dust)"],
    pictograms: ["Corrosive / irritant", "Health hazard"],
    ppe: ["Waterproof gloves", "Sealed eye protection", "P2 dust mask", "Long sleeves"],
    handling: "Avoid raising dust — use water suppression or on-tool extraction when cutting/grinding. Prevent wet cement contact with skin; do not kneel in wet concrete without protection.",
    storage: "Store bags dry and off the ground. Keep away from moisture.",
    incompatibilities: "Acids; water (sets/generates heat).",
    first_aid: "Eyes: rinse immediately for 15 minutes and seek medical attention. Skin: wash off promptly; treat burns. Inhaled dust: move to fresh air.",
    spill_response: "Vacuum (HEPA) or dampen before sweeping to avoid dust. Collect dry for disposal.",
    fire_response: "Non-combustible.",
    emergency_notes: "Serious eye contact or chemical burns: seek medical attention; call 111 if severe.",
  },
  {
    key: "bitumen",
    product_name: "Bitumen / Hot Asphalt",
    category: "Surfacing",
    un_number: "UN3257",
    default_unit: "tonne",
    physical_form: "Hot liquid / solid",
    signal_word: "Danger",
    hazard_summary: "Elevated-temperature material — causes severe thermal burns. Hot fumes irritate eyes and respiratory tract.",
    hazard_classifications: ["Elevated Temperature Liquid", "STOT Single Cat 3 (fumes)"],
    pictograms: ["Health hazard"],
    ppe: ["Heat-resistant gloves", "Face shield", "Long sleeves/overalls", "Respiratory protection for fumes"],
    handling: "Avoid skin contact with hot material. Work upwind of fumes. Keep water out of hot bitumen (violent boil-over/splatter).",
    storage: "Keep heated tanks at controlled temperature. Keep away from water ingress.",
    incompatibilities: "Water (when hot); strong oxidisers.",
    first_aid: "Hot bitumen burns: cool with water, do NOT attempt to remove bitumen from skin — seek urgent medical care. Fumes: move to fresh air.",
    spill_response: "Allow to cool and solidify where safe, then remove mechanically. Keep clear of drains.",
    fire_response: "Dry powder or foam. Do not use water jet on hot bitumen.",
    emergency_notes: "Serious burns: call 111. Cool the burn, cover, do not peel bitumen off.",
  },
  {
    key: "epoxy",
    product_name: "Epoxy Resin / Hardener",
    category: "Coatings & adhesives",
    un_number: "",
    default_unit: "kg",
    physical_form: "Liquid",
    signal_word: "Warning",
    hazard_summary: "Skin and eye irritant and a skin sensitiser — repeated contact can cause allergic dermatitis. Harmful to aquatic life. Hardener may be corrosive.",
    hazard_classifications: ["Skin Irritation Cat 2", "Eye Irritation Cat 2", "Skin Sensitisation Cat 1", "Aquatic Chronic Cat 2"],
    pictograms: ["Corrosive / irritant", "Health hazard", "Environment"],
    ppe: ["Nitrile gloves", "Safety glasses/goggles", "Long sleeves"],
    handling: "Avoid all skin contact — sensitisation is permanent. Mix in ventilated areas. Do not wear contaminated gloves/clothing.",
    storage: "Store resin and hardener separately in labelled containers, cool and dry, away from oxidisers.",
    incompatibilities: "Strong oxidisers; strong acids/bases (hardeners).",
    first_aid: "Skin: wash with soap and water (not solvent). Eyes: rinse 15 minutes, seek medical advice. Swallowed: rinse mouth, seek advice.",
    spill_response: "Contain with absorbent, keep out of drains, collect for disposal. Allow mixed resin to cure before disposal where appropriate.",
    fire_response: "Dry powder, foam or CO2.",
    emergency_notes: "Allergic reaction or eye injury: seek medical attention.",
  },
  {
    key: "solvent",
    product_name: "Mineral Turpentine / Solvent",
    category: "Coatings & adhesives",
    un_number: "UN1300",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Danger",
    hazard_summary: "Flammable liquid. Harmful if swallowed and enters airways. May cause drowsiness/dizziness and skin irritation.",
    hazard_classifications: ["Flammable Liquid Cat 3", "Aspiration Hazard Cat 1", "STOT Single Cat 3", "Skin Irritation Cat 2"],
    pictograms: ["Flammable", "Health hazard"],
    ppe: ["Nitrile gloves", "Safety glasses", "Ventilation / respirator in confined areas"],
    handling: "Keep away from ignition. Use with ventilation. Avoid breathing vapour and skin contact.",
    storage: "Store in a cool ventilated flammables store in labelled containers away from oxidisers.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "Swallowed: do not induce vomiting, seek medical advice. Skin/eyes: wash/rinse. Inhalation: fresh air.",
    spill_response: "Remove ignition sources, ventilate, contain with absorbent, keep out of drains.",
    fire_response: "Foam, dry powder or CO2. Do not use water jet.",
    emergency_notes: "Fire or large spill: evacuate, call 111. Poisons: 0800 764 766.",
  },
  {
    key: "aerosol-paint",
    product_name: "Aerosol Spray Paint / Marker",
    category: "Coatings & adhesives",
    un_number: "UN1950",
    default_unit: "each",
    physical_form: "Aerosol",
    signal_word: "Danger",
    hazard_summary: "Extremely flammable aerosol. Pressurised container — may burst if heated. Vapour may cause drowsiness/dizziness.",
    hazard_classifications: ["Flammable Aerosol Cat 1", "Gas Under Pressure", "STOT Single Cat 3"],
    pictograms: ["Flammable", "Gas cylinder", "Health hazard"],
    ppe: ["Gloves", "Safety glasses", "Ventilation"],
    handling: "Keep away from ignition and no smoking. Do not spray toward flame. Use in ventilated areas; do not pierce or burn cans even when empty.",
    storage: "Store below 50°C out of direct sun in a ventilated area away from ignition.",
    incompatibilities: "Heat, ignition sources, oxidisers.",
    first_aid: "Inhalation: fresh air. Eyes/skin: rinse/wash. Seek advice if symptoms persist.",
    spill_response: "Ventilate and remove ignition sources for leaking cans; dispose of damaged cans safely.",
    fire_response: "Dry powder or CO2. Cool exposed cans — they can rupture.",
    emergency_notes: "Fire: evacuate, cans may explode, call 111.",
  },
  {
    key: "brick-acid",
    product_name: "Hydrochloric Acid (Brick/Concrete Cleaner)",
    category: "Cleaners & chemicals",
    un_number: "UN1789",
    default_unit: "L",
    physical_form: "Liquid",
    signal_word: "Danger",
    hazard_summary: "Causes severe skin burns and eye damage. May cause respiratory irritation from fumes.",
    hazard_classifications: ["Skin Corrosion Cat 1B", "Serious Eye Damage Cat 1", "STOT Single Cat 3 (respiratory)", "Metal Corrosive Cat 1"],
    pictograms: ["Corrosive"],
    ppe: ["Chemical-resistant gloves", "Goggles + face shield", "Apron", "Respiratory protection for fumes"],
    handling: "Always add acid to water, never water to acid. Avoid fumes — work with ventilation. Keep away from metals and alkalis.",
    storage: "Store upright in a corrosive-resistant, bunded, ventilated area away from alkalis and metals. Keep clearly labelled.",
    incompatibilities: "Alkalis (e.g. caustic soda, cement), metals, bleach (releases chlorine gas), oxidisers.",
    first_aid: "Skin/eyes: rinse with running water for 15+ minutes and seek medical attention. Swallowed: rinse mouth, do not induce vomiting, urgent medical care. Inhaled: fresh air.",
    spill_response: "Ventilate, wear full PPE, neutralise cautiously (e.g. soda ash) and absorb; keep out of drains and away from metals.",
    fire_response: "Non-combustible, but reacts with metals to release flammable hydrogen. Use water spray to disperse fumes.",
    emergency_notes: "Burns, eye contact or fume inhalation: call 111 / Poisons Centre 0800 764 766. Never mix with bleach.",
  },
  {
    key: "glyphosate",
    product_name: "Glyphosate Weedkiller",
    category: "Site preparation",
    un_number: "",
    default_unit: "L",
    physical_form: "Liquid concentrate",
    signal_word: "Warning",
    hazard_summary: "Causes serious eye irritation. Harmful to aquatic life. Avoid contact and do not contaminate waterways.",
    hazard_classifications: ["Eye Irritation Cat 2", "Aquatic Chronic Cat 2"],
    pictograms: ["Corrosive / irritant", "Environment"],
    ppe: ["Gloves", "Eye protection", "Overalls / long sleeves"],
    handling: "Mix and apply per label rate. Avoid spray drift and do not apply near water. Wash hands after use.",
    storage: "Store in original labelled container, cool and dry, away from food and waterways.",
    incompatibilities: "Strong oxidisers.",
    first_aid: "Eyes: rinse 15 minutes, seek advice. Skin: wash. Swallowed: rinse mouth, seek medical advice — take the label.",
    spill_response: "Contain with absorbent, keep out of drains and waterways, collect for disposal.",
    fire_response: "Water spray, foam or dry powder.",
    emergency_notes: "Poisoning advice: National Poisons Centre 0800 764 766.",
  },
];

export const CATALOGUE_FIELDS = [
  "product_name", "un_number", "default_unit", "physical_form", "signal_word",
  "hazard_summary", "hazard_classifications", "pictograms", "ppe",
  "handling", "storage", "incompatibilities", "first_aid", "spill_response",
  "fire_response", "emergency_notes",
];

// Build the create-substance body from a catalogue entry.
export function catalogueToSubstanceBody(entry) {
  const body = { description: "Added from Fieldlink common-substance library. Attach the supplier SDS to confirm product-specific details." };
  for (const f of CATALOGUE_FIELDS) {
    if (entry[f] !== undefined) body[f] = entry[f];
  }
  return body;
}
